export const MAP_LOCALE_TO_ID = {
  en: 4,
  cs: 3,
  pl: 16,
  fr: 314,
  it: 177,
  es: 223,
  de: 269,
};
